import React, { useState } from "react";
import { Link } from 'react-router-dom';
import hr from "../../images/banner/hr.png";
import "bootstrap-icons/font/bootstrap-icons.css";
import axios from 'axios';
import AuthUser from '../AuthUser';

const servicesStyle = {
    backgroundImage: `url(${hr})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundColor :'#e6f4ff',
    width :'100%',
    height: '33vh',
};

const Addagreement = () => {

    const {usertype,logout,getUser} = AuthUser();
    let userdetails = getUser();
    
    const [formData, setFormData] = useState({
		employeename: '',
        documenttitle: '',
        documents: '',
        empid: userdetails.empid,
    });

    const invalidfeedback = {
        display: 'block',
        width: '100%',
        fontSize: '12px',
        color : '#dc3545',
        marginLeft : '0px'
    };
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [errors, setErrors] = useState({});
    const [error, setError] = useState('');
	const [success, setSuccess] = useState('');
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
        
    };
    const handleFileuploadChange =(e) =>{
        const documents = Array.from(e.target.files);
        setSelectedFiles(documents);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
		console.log(formData);
        let employeename=e.target.employeename.value;
        let documenttitle=e.target.documenttitle.value;
        let documents = e.target.documents.files;

       
        try {
            const response = await axios.post(`https://api.transnational.ai/api/addhragreement`, {employeename:employeename,documenttitle:documenttitle,documents:documents}, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              });
            console.log(response.data.name);

            setErrors({});
			setSuccess(response.data.message);
        } catch (error) {
            //console.log(error.response.status)
            if (error.response && error.response.status === 422) {
                setErrors(error.response.data.errors);
            }else if (error.response && error.response.status === 401) {
                setError(error.response.data.errormessage);
            } else {
                console.error('Error submitting form:', error);
                
            }
        }
    };

    return (
        <section style={{ backgroundColor:'#f4f4f4' }}>
            <section id="bannerSection" style={servicesStyle}>
                <div className="container">
                    <h1 id="HR"></h1>
                </div>
            </section>
            <div className="media-body" style={{ minHeight:'500px', padding:'10px'}}>
		        <div className="container">
			        <div className="col-12" style={{ }}>
				        <div className="well well-small" style={{ textAlign:'left', backgroundColor:'#fff' }}>
					        <ul className="media-list">
						        <li className="media well well-small" style={{ marginTop:'10px',marginLeft:'-15px',marginRight:'15px',marginBottom:'-5px'}}>
                                    <section className="breadcrumb" style={{ marginLeft:'5px', marginTop:'5px',marginRight:'5px'}}>
                                        <div  className="col-12 breadcrumbs" >
                                            <a href="/hr/Dashboard">Home</a> <i class="bi bi-chevron-double-right"></i> <span>Add Document</span>
                                        </div>
                                    </section>
                            
                                    <div className="container" style={{ minHeight:'400px'}}>
                                        { success !== '' && <div className="alert alert-success">{success}</div> }
                                        { error !== '' && <div className="alert alert-danger">{error}</div> }
                                        <form id="addemployee" onSubmit={handleSubmit}>
									    <table width={940} border={0} align="center" cellPadding={10} cellSpacing={10}>
										<tr>
											<td width="250"><span className="label_normal">Employee Name *</span></td>
											<td width="10">:</td>
											<td width="250"><input type="text" name="employeename" maxLength={40} className="ui_text" value={formData.employeename} onChange={handleChange} /></td>
                                            <td>{errors.employeename && <span style={invalidfeedback}>{errors.employeename[0]}</span>}</td>
										</tr>
                                        <tr>
											<td width="250"><span className="label_normal">Document Title *</span></td>
											<td width="10">:</td>
											<td width="250"><input type="text" name="documenttitle" maxLength={40} className="ui_text" value={formData.documenttitle} onChange={handleChange} /></td>
                                            <td>{errors.documenttitle && <span style={invalidfeedback}>{errors.documenttitle[0]}</span>}</td>
										</tr>
                                        <tr>
											<td><span className="label_normal">Documents *</span></td>
											<td>:</td>
											<td><input type="file" multiple name="documents"  onChange={handleFileuploadChange}/></td>
                                            <td>{errors.documents && <span style={invalidfeedback}>{errors.documents}</span>}</td>
										</tr>
										<tr>
											<td>&nbsp;</td>
											<td></td>
											<td height="50"><input name="addemployee" type="submit" value="Submit" className="btn btn-primary btn-block" style={{ width:'220px'}} /></td>
                                            <td></td>
										</tr>
									    </table>
								        </form> 
                                        <br/>
							        </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>       
        </section>
    );
}

export default Addagreement;